/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskProgramServiceRevenue
 */
export interface ExecRiskProgramServiceRevenue {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskProgramServiceRevenue
     */
    Desc?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskProgramServiceRevenue
     */
    BusinessCd?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskProgramServiceRevenue
     */
    TotalRevenueColumnAmt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskProgramServiceRevenue
     */
    RelatedOrExemptFuncIncomeAmt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskProgramServiceRevenue
     */
    UnrelatedBusinessRevenueAmt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskProgramServiceRevenue
     */
    ExclusionAmt?: number;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskProgramServiceRevenue
     */
    ActivityOrMissionDesc?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskProgramServiceRevenue
     */
    MissionDesc?: string;
}

/**
 * Check if a given object implements the ExecRiskProgramServiceRevenue interface.
 */
export function instanceOfExecRiskProgramServiceRevenue(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskProgramServiceRevenueFromJSON(json: any): ExecRiskProgramServiceRevenue {
    return ExecRiskProgramServiceRevenueFromJSONTyped(json, false);
}

export function ExecRiskProgramServiceRevenueFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskProgramServiceRevenue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'Desc': !exists(json, 'Desc') ? undefined : json['Desc'],
        'BusinessCd': !exists(json, 'BusinessCd') ? undefined : json['BusinessCd'],
        'TotalRevenueColumnAmt': !exists(json, 'TotalRevenueColumnAmt') ? undefined : json['TotalRevenueColumnAmt'],
        'RelatedOrExemptFuncIncomeAmt': !exists(json, 'RelatedOrExemptFuncIncomeAmt') ? undefined : json['RelatedOrExemptFuncIncomeAmt'],
        'UnrelatedBusinessRevenueAmt': !exists(json, 'UnrelatedBusinessRevenueAmt') ? undefined : json['UnrelatedBusinessRevenueAmt'],
        'ExclusionAmt': !exists(json, 'ExclusionAmt') ? undefined : json['ExclusionAmt'],
        'ActivityOrMissionDesc': !exists(json, 'ActivityOrMissionDesc') ? undefined : json['ActivityOrMissionDesc'],
        'MissionDesc': !exists(json, 'MissionDesc') ? undefined : json['MissionDesc'],
    };
}

export function ExecRiskProgramServiceRevenueToJSON(value?: ExecRiskProgramServiceRevenue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Desc': value.Desc,
        'BusinessCd': value.BusinessCd,
        'TotalRevenueColumnAmt': value.TotalRevenueColumnAmt,
        'RelatedOrExemptFuncIncomeAmt': value.RelatedOrExemptFuncIncomeAmt,
        'UnrelatedBusinessRevenueAmt': value.UnrelatedBusinessRevenueAmt,
        'ExclusionAmt': value.ExclusionAmt,
        'ActivityOrMissionDesc': value.ActivityOrMissionDesc,
        'MissionDesc': value.MissionDesc,
    };
}

